import {createSlice} from '@reduxjs/toolkit';
import {MyReportsRequest} from './types';

export interface State {
  data?: any;
  error?: any;
  loading: boolean;
  daysData?: any;
  errorDays?: any;
  loadingDays: boolean;
}

const initialState: State = {
  data: undefined,
  error: undefined,
  loading: false,
  daysData: undefined,
  errorDays: undefined,
  loadingDays: false,
};

export const counterSlice = createSlice({
  name: MyReportsRequest,
  initialState,
  reducers: {
    getMyReportsData: () => {},
    myReportsApiCallLoadingRequest: (state) => {
      state.loading = true;
      state.error = undefined;
    },
    myReportsApiCallSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = undefined;
    },
    myReportsApiCallFailure: (state, action) => {
      if (state.data !== undefined) {
        state.data = undefined;
      }
      state.loading = false;
      state.error = action.payload;
    },
    myReportsDayStartLoading: (state) => {
      state.loadingDays = true;
      state.errorDays = undefined;
    },
    myReportsDayApiCallSuccess: (state, action) => {
      state.daysData = action.payload;
      state.loadingDays = false;
      state.errorDays = undefined;
    },
    myReportsDayApiCallFailure: (state, action) => {
      if (state.daysData !== undefined) {
        state.daysData = undefined;
      }
      state.loadingDays = false;
      state.errorDays = action.payload;
    },
  },
});

export const {
  getMyReportsData,
  myReportsApiCallLoadingRequest,
  myReportsApiCallSuccess,
  myReportsApiCallFailure,
  myReportsDayStartLoading,
  myReportsDayApiCallSuccess,
  myReportsDayApiCallFailure,
} = counterSlice.actions;

export default counterSlice.reducer;
